module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalDefault', {
    attrs: {
      "size": "s",
      "with-content": true,
      "theme": true,
      "fix-height": false,
      "fix-width": false,
      "loading": false
    },
    on: {
      "close": function($event) {
        _vm.close();
      }
    }
  }, [_c('template', {
    slot: "main"
  }, [_c('div', {
    staticClass: "row d-flex align-items-center"
  }, [_c('div', {
    staticClass: "col-auto"
  }, [_c('ClientColorButton', {
    attrs: {
      "size": "m",
      "rounded100": true,
      "background-color": "#F9C53C",
      "color": "#fff"
    }
  }, [_c('i', {
    staticClass: "fa fa-undo-alt fa-lg"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "title mb-0"
  }, [_vm._v(_vm._s(_vm.params.periodHasZone.zone.name.toUpperCase()) + " " + _vm._s(_vm.$t("catalogForecast.market.wasRechallenged")))]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t("catalogForecast.market.rechallengedByOn", {
    user: _vm.params.periodHasZone.lastRechallenge.by.firstname + " " + _vm.params.periodHasZone.lastRechallenge.by.lastname,
    month: _vm.moment(_vm.params.periodHasZone.lastRechallenge.date).format("MM"),
    monthText: _vm.moment(_vm.params.periodHasZone.lastRechallenge.date).format("MMMM"),
    dayth: _vm.moment(_vm.params.periodHasZone.lastRechallenge.date).format("Do"),
    day: _vm.moment(_vm.params.periodHasZone.lastRechallenge.date).format("DD")
  })))])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('p', {
    staticClass: "message-label m-0 mb-2"
  }, [_vm._v(_vm._s(_vm.$t("catalogForecast.market.messageLabel")))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "html-safe",
      rawName: "v-html-safe",
      value: (_vm.params.periodHasZone.lastRechallenge.message.replaceAll('\n', '<br>')),
      expression: "params.periodHasZone.lastRechallenge.message.replaceAll('\\n', '<br>')"
    }],
    staticClass: "message"
  }), _vm._v(" "), _c('p', {
    staticClass: "message-message m-0 mt-2"
  }, [_vm._v(_vm._s(_vm.$t("catalogForecast.market.accessMessage")))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col d-flex justify-content-end mt-5"
  }, [_c('ClientColorButton', {
    attrs: {
      "inactiveColor": true
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("common.ok")) + " ")])], 1)])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15337857","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/catalogForcast/elements/RechallengeInfos.vue
// module id = 3031
// module chunks = 0